"use client";
/** Decorative icons contain no ligature text for visible-label audits to read. */
export function StorefrontIcon({ name }: { name: "cart" | "product" }) {
  return <svg className="material-symbols-outlined webshops-storefront-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"
    width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {name === "cart" ? <><path d="M2 3h3l3 12h11l3-9H6M8 15l-1 3h13" /><circle cx="9" cy="21" r="1" /><circle cx="18" cy="21" r="1" /></>
      : <><path d="M3 7h18v14H3zM2 3h20v4H2zM9 11h6" /></>}
  </svg>;
}
